document.addEventListener("DOMContentLoaded", function () {
    function setupDropdown() {
        const menuItem = document.getElementById("ti-menu-item-with-dropdown");
        const dropdown = document.getElementById("ti-menu-dropdown");

        if (!menuItem || !dropdown) return;

        const arrowSpan = menuItem.querySelector("span");

        menuItem.addEventListener("click", function (event) {
            dropdown.classList.toggle("block");
            dropdown.classList.toggle("hidden");
            menuItem.classList.toggle("text-skin-onColor");
            menuItem.classList.toggle("text-skin-onColor/80");

            if (arrowSpan) {
                arrowSpan.style.transform = dropdown.classList.contains("block") ? "rotate(180deg)" : "rotate(0deg)";
                arrowSpan.style.transition = "transform 0.3s ease";
            }
            event.stopPropagation();
        });

        document.addEventListener("click", function (event) {
            if (!menuItem.contains(event.target) && !dropdown.contains(event.target)) {
                dropdown.classList.remove("block");
                dropdown.classList.add("hidden");
                menuItem.classList.add("text-skin-onColor/80");
                menuItem.classList.remove("text-skin-onColor");

                if (arrowSpan) {
                    arrowSpan.style.transform = "rotate(0deg)";
                }
            }
        });
    }

    setupDropdown();
});
